import { Component, OnInit } from '@angular/core';
import { ProductoService } from '../../../services/producto/producto.service';
import { supplierIntegrationService } from '../../../services/supplierIntegration/supplier-integration.service';
import { HttpErrorResponse } from '@angular/common/http';
import { MessageService } from 'primeng/api';
import { CatalogoService } from '../../..//services/catalogo/catalogo.service';

@Component({
  selector: 'app-sincronizacion-siigo',
  templateUrl: './sincronizacion-siigo.component.html',
  styleUrls: ['./sincronizacion-siigo.component.scss'],
  standalone: false,
  providers: [MessageService]
})
export class SincronizacionSIIGOComponent implements OnInit {

  loadMenu: boolean = true;
  load: boolean = false;
  token: any = {};
  listProducts: Array<any> = [];
  listProductsStore: Array<any> = [];
  infoParametrizacion: any = {};
  infoEmpresa: any = {};
  tokenSIIGO: any = {};
  infoSKU: any = {}
  contador: number = 0;
  contadorError: number = 0;
  lsProductsErrors: Array<string> = [];
  displayLoading: boolean = false;
  productID: string = "";
  numProgress: number = 0;

  constructor(private integracion: supplierIntegrationService,
    private message: MessageService,
    private catalogo: CatalogoService
  ) { }

  ///
  ngOnInit(): void {
    this.token = JSON.parse(localStorage.getItem('token') ?? "".toString());
    this.infoParametrizacion = JSON.parse(localStorage.getItem('parametros') ?? "");
    this.infoEmpresa = JSON.parse(localStorage.getItem('empresa') ?? "[]");


    // get products in general
    if (!localStorage.getItem("listProducts"))
      this.catalogo.getProductosProveedor(this.token.token).subscribe((response: any) => {
        this.listProducts = response as Array<any>;
        localStorage.setItem("listProducts", JSON.stringify(this.listProducts))

      });
    else
      this.listProducts = JSON.parse(localStorage.getItem("listProducts") ?? "[]");

    console.log('listado de productos', this.listProducts);

    // conocer el token de SIIGO

    if (this.infoParametrizacion.integrationSystem == 'SIIGO') {
      if (!!this.infoParametrizacion.dataIntegrationUser) {
        //********************************** get Token SIIGO *******************************************
        const data: any = {
          "dataIntegrationUser": this.infoParametrizacion.dataIntegrationUser,
          "dataIntegrationApikey": this.infoParametrizacion.dataIntegrationApikey
        }
        this.integracion.getTokenSIIGO(this.token.token, data).subscribe({
          next: (response) => {
            this.tokenSIIGO = response as any;
          },
          error: (error: HttpErrorResponse) => {
            this.message.add({
              severity: 'error',
              detail: 'Se ha presentado un error con el proveedor SIIGO, no es posible conectarse, cierre sesión e intente nuevamente'
            });
          }
        });
      }
    }
  }

  /**
   * Importar información de cada producto según la codificación del coódigo de barras
   * @param codBarras 
   */
  querySKU = (codBarras: string): Promise<string> => {
    console.log(codBarras);
    return new Promise((resolve, reject) => {
      this.integracion.getProductSiigoSKU(this.token.token, this.tokenSIIGO, codBarras).subscribe({
        next: (response) => {
          this.infoSKU = response as any;
          try {
            // si hay información damos coninuidad al proceso
            if (this.infoSKU?.results.length > 0) {
              let infoPrecios, infoBodegas;
              console.log(this.infoSKU?.results[0]);
              // se debe actualizar el id de Tax a aplicar al producto
              if (!!this.infoSKU?.results[0]?.taxes) {
                console.log('si tiene impuestos', this.infoSKU?.results[0].taxes[0].id);
              }

              //equivalencia de inventario bodegas en nuestro caso son tiendas
              if (!!this.infoSKU?.results[0]?.warehouses) {
                infoBodegas = this.infoSKU?.results[0]?.warehouses.map((row: any) => {
                  return row.id + ":" + row.quantity
                })
                console.log('Tiene cantidades en Bodega', infoBodegas?.length > 0 ? infoBodegas.join('|') : "");
              }

              // equivalencia del precio
              // se tiene encuenta el tema de impuestos
              if (!!this.infoSKU?.results[0]?.prices) {
                infoPrecios = this.infoSKU?.results[0]?.prices[0].price_list.map((row: any) => {
                  return row.name + ":" + (!this.infoSKU?.results[0].tax_included ? row.value * ((this.infoSKU?.results[0].taxes[0].percentage / 100) + 1) : row.value)
                })
                console.log('Tiene precios', infoPrecios?.length > 0 ? infoPrecios.join('|') : "");
              }

              const data = {
                "idProveedor": null,
                "codBarras": codBarras,
                "idUser": null,
                "idTaxesExternSystem": this.infoSKU?.results[0].taxes[0].id,
                "strBodega": infoBodegas?.length > 0 ? infoBodegas.join('|') : "",
                "strPrecios": infoPrecios?.length > 0 ? infoPrecios.join('|') : ""
              }
              console.log(data);

              this.integracion.setSKUFromSIIGO(this.token.token, data).subscribe({
                next: (response) => {
                  resolve(response as string);
                },
                error: (error: HttpErrorResponse) => { reject(error); console.log("se ha presentando un error", error) }
              })


            }
          }
          catch (error) {
            console.log('hay', error);
            reject(error as string);
          }

        },
        error: (error: HttpErrorResponse) => { reject(error); console.log(error) }
      })
    });
  }

  /**
   Este proceso se encarga de sincronizar los productos en SIIGO
   */
  beginProcessN = () => {
    this.displayLoading = true;
    this.contador = 0;
    let array = this.listProducts;
    let process = [];
    let position = 0;
    let flag: boolean = false; // para saber si esta procesando
    console.log(array);
    let interval = setInterval(() => {
      console.log('entro');
      if (flag == false) {
        flag = true;
        console.log('entro y en espera del proceso');
        // entra pero espera que finalice la carga
        this.querySKU(array[position].codBarras).then(value => {
          this.contador = this.contador + 1;
          this.numProgress = Math.round((this.contador / array.length) * 100)
          position++;
          flag = false;
          console.log('Salida del proceso', value)
          return value;
        })
          .catch((error) => {
            this.contador = this.contador + 1;
            this.numProgress = Math.round((this.contador / array.length) * 100)
            this.contadorError = this.contadorError + 1;
            this.lsProductsErrors.push(array[position].codBarras);
            console.log(error);
            position++;
            flag = false;
            return error;
          });;

        if (position > array.length)
          clearInterval(interval);
      }
    }, 3000)

  }


}
